import { render, staticRenderFns } from "./ProductSelectInfoPopover.vue?vue&type=template&id=2ebe9b80&scoped=true&"
import script from "./ProductSelectInfoPopover.vue?vue&type=script&lang=js&"
export * from "./ProductSelectInfoPopover.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelectInfoPopover.vue?vue&type=style&index=0&id=2ebe9b80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebe9b80",
  null
  
)

export default component.exports